// ----------------------------------------------------------------------

import { JobRecruitmentType } from 'src/services/jobs/jobs.types';
import { User } from 'src/services/organisation/organisation.types';
import { DealType, IDealStage } from 'src/services/deal-flow/deal-flow.types';
import { ApplicationStage, RepresentationStatus } from 'src/services/applications/applications.types';

export enum CardType {
  Job = 'job',
  Application = 'application',
  Job_Invite = 'job-invite',
}


export type IKanbanAssignee = {
  id: string;
  name: string;
  role: string;
  email: string;
  status: string;
  address: string;
  avatarUrl: string;
  phoneNumber: string;
  lastActivity: Date;
};

export type IKanbanJobCard = {
  id?: string;
  index: number;
  jobTitle: string;
  employerTitle?: string;
  type: CardType;
  agencyTitle?: string;
  status?: string;
  description?: string;
  assignee?: IKanbanAssignee[];
  due?: [Date | null, Date | null];
  reporter?: {
    id: string;
    name: string;
    avatarUrl: string;
  };
  avatarUrl?: string;
  hasAttachment: boolean;
  isLinked: boolean;
  excitementLevel?: number;
  selected?: boolean;
};

export type IKanbanApplicationCard = {
  id?: string;
  index: number;
  type: CardType;
  candidateName: string;
  recruiterName?: string;
  positionTitle?: string;
  avatarUrl?: string;
  stage?: ApplicationStage;
  rating?: number;
  isShortlisted?: boolean;
  interviewPhase?: number;
  requestedStage?: ApplicationStage;
  isExternallyManaged: boolean;
  hasVerifiedClient: boolean;
  /** Backed by a JobTetris candidate account. A local applicant is not, so is never notified. */
  isLiveCandidate: boolean;
  representation_status?: RepresentationStatus;
  selected?: boolean;
};

export type IKanbanColumn<T> = {
  id: string;
  name: string;
  tasks: T[];
  stage: string;
  order: number;
  color?: string;
  tooltip?: string;
};

export type IKanban<T> = {
  tasks: Record<string, T>;
  columns: Record<string, IKanbanColumn<T>>;
  ordered: string[];
};

export type IKanbanDealCard = {
  id?: string;
  index: number;
  title: string;
  description?: string;
  value?: number;
  type: DealType;
  close_date?: Date;
  stage?: IDealStage
  assigned_to?: Partial<User>;
  job_title?: string;
  job_description?: string;
  job_vacancies?: number;
  job_recruitment_type?: JobRecruitmentType;
  currency?: string;
  selected?: boolean;
};
